<div #videoContainer class="video-container" [class.zoomed]="zoomLevel() > 1" [class.expanded]="expanded()">
  @if (zoomLevel() > 1 && !dragTipDismissed()) {
    <div class="drag-tip-anchor">
      <div class="drag-tip">
        <mat-icon class="text-sm">pan_tool</mat-icon>
        <span class="text-sm">Drag to pan</span>
        <app-pan-button icon="close" size="sm" fill="clear" (click)="dragTipDismissed.set(true)"></app-pan-button>
      </div>
    </div>
  }
  <div class="video-wrapper" [style.transform]="'scale(' + zoomLevel() + ')'">
    <video
      #videoElement
      [controls]="nativeControlsVisible()"
      class="w-full"
      (loadedmetadata)="this.setPlaybackSpeed(this.playbackSpeed(), videoElement)"
      (play)="isPlaying.set(true)"
      (pause)="isPlaying.set(false)"
    >
      <source [src]="src()" type="video/mp4" />
    </video>
    @if (zoomLevel() > 1) {
      <div
        class="drag-overlay"
        (mousedown)="onMouseDown($event, videoContainer)"
        (mousemove)="onMouseMove($event, videoContainer)"
        (mouseup)="isDragging.set(false)"
        (mouseleave)="isDragging.set(false)"
      ></div>
    }
  </div>
</div>
@if (showControls()) {
  <div class="flex items-center gap-1 bg-gray-200 p-2" data-testid="pan-video-controls">
    <app-pan-button
      [icon]="isPlaying() ? 'pause' : 'play_arrow'"
      color="primary"
      size="sm"
      (click)="videoElement.paused ? videoElement.play() : videoElement.pause()"
      [matTooltip]="isPlaying() ? 'Pause' : 'Play'"
    ></app-pan-button>
    <div class="w-px h-6 bg-gray-400 mx-1"></div>
    <app-pan-button
      icon="zoom_out"
      color="primary"
      size="sm"
      (click)="zoomOut()"
      [disabled]="zoomLevel() <= 1"
      matTooltip="Zoom out"
    ></app-pan-button>
    <span class="text-sm text-gray-600 mx-1">{{ zoomLevel() * 100 }}%</span>
    <app-pan-button
      icon="zoom_in"
      color="primary"
      size="sm"
      (click)="zoomIn()"
      [disabled]="zoomLevel() >= 5"
      matTooltip="Zoom in"
    ></app-pan-button>
    @if (zoomLevel() > 1) {
      <app-pan-button icon="restart_alt" color="primary" size="sm" (click)="zoomLevel.set(1)" matTooltip="Reset zoom"></app-pan-button>
    }
    <div class="flex-1"></div>
    <app-pan-button-group>
      @for (speed of availablePlaybackSpeeds; track speed) {
        <app-pan-button
          size="sm"
          color="primary"
          [width]="48"
          [fill]="playbackSpeed() === speed ? 'filled' : 'outline'"
          (click)="setPlaybackSpeed(speed, videoElement)"
        >
          {{ speed }}x
        </app-pan-button>
      }
    </app-pan-button-group>
    <div class="w-px h-6 bg-gray-400 mx-1"></div>
    <app-pan-button
      [icon]="nativeControlsVisible() ? 'visibility_off' : 'visibility'"
      color="primary"
      size="sm"
      (click)="toggleNativeControls()"
      [ariaLabel]="nativeControlsVisible() ? 'Hide built-in player controls' : 'Show built-in player controls'"
      [matTooltip]="nativeControlsVisible() ? 'Hide built-in player controls' : 'Show built-in player controls'"
    ></app-pan-button>
    <app-pan-button
      [icon]="expanded() ? 'fullscreen_exit' : 'fullscreen'"
      color="primary"
      size="sm"
      (click)="toggleExpanded()"
      [ariaLabel]="expanded() ? 'Exit full screen' : 'Full screen'"
      [matTooltip]="expanded() ? 'Exit full screen' : 'Full screen'"
    ></app-pan-button>
  </div>
}
